import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const StyledLockLabel = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: ${props => props.theme.dark2};
  margin-bottom: 16px;
  font-weight: 500;
  span {
    color: ${props => props.theme.primaryColor};
  }
`

export const PayLock: React.FC<{
  lockTime: number
}> = ({ lockTime }) => {
  const [downcount, setDowncount] = useState(lockTime)

  useEffect(() => {
    // 备注：锁单倒计时
    const timer = setInterval(() => {
      if (downcount > 0) {
        setDowncount(count => count - 1)
      } else {
        clearInterval(timer)
      }
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [downcount])

  return (
    <StyledLockLabel>
      订单有效时长{lockTime}s，请及时付款，剩余支付时间{' '}
      <span>{downcount}s</span>
    </StyledLockLabel>
  )
}
